<template>
    <div class="news__slider">

        <div class="mobile__headline">
            <p class="red">OUR</p>
            <p class="white">NEWS</p>
        </div>

        <img class="slider_icon" src="/images/icons/left_white.webp" alt="prev news" @click="changeNews(-1, true)" />

        <div class="current__news">
            <div class="wrapper">
                <div class="left_overlay"></div>
                <div class="right_overlay"></div>
                <div class="subline__date">
                    <p class="subline">{{this.current_news.subline}}</p>
                    <p class="date">{{this.current_news.date}}</p>
                </div>
                <div class="headline__shortdesc">
                    <p class="headline">{{this.current_news.title}}</p>
                    <div class="short_desc" v-html=this.current_news.short_description></div>
                </div>
                <a class="mobile__link" :href="'/news/' + this.current_news.slug"><p>MORE DETAILS</p></a>
                <div class="featured__image" v-bind:style="this.current_news.featured_image_styles"></div>
                <template v-if="news.length > 1">
                    <div class="progress"><div id="progressbar" class="in animate"></div></div>
                </template>
            </div>
            <a class="read__more" :href="'/news/' + this.current_news.slug">
                <p>read more...</p>
                <div class="span_bg"></div>
            </a>
        </div>

        <img class="slider_icon" src="/images/icons/right_white.webp" alt="next news" @click="changeNews(1, true)" />

        <div class="mobile__navigation">
            <div class="next" @click="changeNews(-1, true)">
                <img src="/images/icons/left.webp" alt="prev news">
                <p class="text">PREVIOUS NEWS</p>
            </div>
            <div class="prev" @click="changeNews(1, true)">
                <p class="text">NEXT NEWS</p>
                <img src="/images/icons/right.webp" alt="next news">
            </div>

        </div>

    </div>
</template>
<script>
    export default {
        data(){
            return {
                // news: [
                //     {
                //         subline: 'presentation',
                //         date:   '2 December at 13:07',
                //         headline: 'FUTURES LEADERS SUMMIT',
                //         short_desc: 'Our Business Development Manager held a presentation aimed for students of all discipline, as a part of Futures Leaders Summit. <br><br>We aim to be more and more active and supportive for our local community and youth.',
                //         featured_image: '/images/news/placeholders/futures_leaders_summit.webp',
                //     },
                //     {
                //         subline: 'remake',
                //         date:   '12 August at 22:22',
                //         headline: 'GOTHIC 1 REMAKE',
                //         short_desc: 'You loved Gothic 1, 2 and 3? Well, Gothic 1 Remake trailer is out and we are super happy to mention that we are developing characters and rigs for this amazing franchise, together with Alkimia Interactive.<br><br>#gothic #alkimiainteractive THQNordic',
                //         featured_image: '/images/news/placeholders/gothic_1_remake.webp'
                //     },
                //     {
                //         subline: 'achievement',
                //         date:   '24 January at 12:30',
                //         headline: 'YOUTH, DEVELOPMENT - EDUCATION',
                //         short_desc: 'We thank Arman and Hasan who have, along with the other lecturers, showed the other side of Bosnia and Herzegovina to young people who are currently considering what they could do tomorrow, and what is it that they can do today. #zimskaskolaudistilandu #gate21',
                //         featured_image: '/images/news/placeholders/youth_education.webp'
                //     }
                // ],
                current_news: {
                    subline: null,
                    date:  null,
                    headline: null,
                    short_desc: null,
                    featured_image: null,
                    featured_image_styles: null,
                },
                slider_index: 0,
                autoplay_on: true,
                NEWS_AUTOPLAY_TIMER: 15000,
                NEWS_TIMEOUT: null,
            }
        },
        props: ['news'],
        created(){},
        mounted(){
            this.setCurrentNews(0);
        },
        methods: {
            changeNews(direction, manual_switch = false){
                if(direction === -1){
                    if(this.slider_index === 0){
                        this.setCurrentNews(this.news.length -1);
                    } else {
                        this.setCurrentNews(this.slider_index - 1);
                    }
                } else {
                    if(this.slider_index == this.news.length - 1){
                        this.setCurrentNews(0);
                    } else {
                        this.setCurrentNews(this.slider_index + 1);
                    }
                }

                if(manual_switch){
                    this.autoplay_on = false;
                    this.stopProgressBar();
                    this.clearAutoPlayTimeouts();
                }
            },

            setCurrentNews(index){
                this.slider_index = index;
                this.current_news = this.news[index];
                this.current_news.featured_image_styles = {
                    background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(0deg, rgba(92, 44, 144, 0.3), rgba(92, 44, 144, 0.3)),' + 
                    "url('/image/" + this.current_news.media_path + '/' + this.current_news.featured_image + "')"
                    + ' center'
                }

                // autoplay of video and next project switch
                if(this.autoplay_on){
                    this.setAutoPlayTimeouts();
                } else {
                    this.clearAutoPlayTimeouts();
                    this.restartProgressBar();
                }
            },

            setAutoPlayTimeouts(){
                if(this.news.length < 2) return;
    
                this.NEWS_TIMEOUT = setTimeout(() => {
                    this.restartProgressBar();
                    this.changeNews(1, false);

                }, this.NEWS_AUTOPLAY_TIMER);

            },

            restartProgressBar(){
                const bar = document.getElementById('progressbar');
                if(bar.classList.contains('animate')) {
                    bar.style.animation = 'none';
                    bar.offsetHeight; /* trigger reflow */
                    bar.style.animation = null; 
                    bar.classList.remove('animate'); 
                    bar.classList.add('animate');
                };
            },

            stopProgressBar(){
                const bar = document.getElementById('progressbar');
                if(bar.classList.contains('animate')) {
                    bar.style.animation = 'none';
                }
            },

            clearAutoPlayTimeouts(){
                clearTimeout(this.NEWS_TIMEOUT);
            },
        },
        
    }
</script>
<style lang="scss" scoped>

    .news__slider{
        display: flex;
        flex-direction: row;
        justify-content: center;
        // background: #000000;
        background: linear-gradient(180deg, #2A1542 0%, #000000 100%);
        padding-top: 120px;

        min-width: 1111px;
        max-width: 1111px;
        // height: 100%;
        max-height: 100%;

        .mobile__headline{
            display: none;
            flex-direction: column;
            border-bottom: 1px solid #ED1163;
            margin-top: 5px;
            margin-bottom: 10px;

            .red{
                font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;
                font-style: normal;
                // font-weight: 400;
                font-size: 14px;
                line-height: 17px;
                /* identical to box height */

                color: #ED1163;
                margin: 0;
                margin-right: 11px;
                margin-left: auto;
            }

            .white{
                font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                font-style: normal;
                font-weight: 700;
                font-size: 16px;
                line-height: 19px;

                color: #FFFFFF;
                margin: 0;
                margin-right: 11px;
                margin-left: auto;
            }
        }


        img.slider_icon{
            width: 12px;
            height: 21px;

            margin-top: auto;
            margin-bottom: auto;
            margin-left: auto;
            margin-right: auto;

            display: block;
            cursor: pointer;
        }

        .current__news{
            width: 100%;
            max-width: 906px;
           
            .wrapper{
                background: linear-gradient(0deg, rgba(92, 44, 144, 0.4), rgba(92, 44, 144, 0.4)), #212121;
                position: relative;

                box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                width: 100%;

                .left_overlay{
                    position: absolute;
                    bottom: 0;
                    left: 0;

                    background: url('/images/news/overlay/left.webp');
                    width: 347px;
                    height: 481px;
                    background-repeat: no-repeat;
                }

                .right_overlay{
                    position: absolute;
                    bottom: 0;
                    right: 0;

                    background: url('/images/news/overlay/right.webp');
                    width: 345px;
                    height: 602px;
                    background-repeat: no-repeat;
                }


                .subline__date{
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    padding-top: 50px;
                    padding-left: 80px;
                    padding-right: 80px;

                    .subline{
                        font-family: 'DIN Next LT Pro Medium', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        font-weight: 500;
                        font-size: 18px;
                        line-height: 22px;
                        text-align: left;

                        margin: 0;

                        color: #ED1163;
                    }

                    .date{
                        font-family: 'DIN Next LT Pro UltraLight', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        font-weight: 300;
                        font-size: 12px;
                        line-height: 14px;
                        text-align: right;

                        margin: 0;

                        color: #FFFFFF;
                    }
                }            

                .headline__shortdesc{
                    display: flex;
                    flex-direction: column;

                    padding-left: 80px;
                    padding-right: 80px;

                    .headline{
                        font-family: 'DIN Next LT Pro Medium', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        font-weight: 700;
                        font-size: 50px;
                        line-height: 60px;

                        width: 100%;
                        max-width: 564px;
                        min-height: 120px;

                        margin: 0;
                        margin-bottom: 25px;

                        color: #FFFFFF;
                        z-index: 1;
                    }

                    .short_desc{
                        font-family: 'DIN Next LT Pro UltraLight', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        font-weight: 300;
                        font-size: 18px;
                        line-height: 22px;
                        display: flex;
                        // align-items: center;
                        align-items: flex-start;

                        width: 100%;
                        max-width: 639px;
                        height: 135px;

                        margin-bottom: 28px;

                        color: #FFFFFF;
                        z-index: 1;
                    }

                }

                .mobile__link{
                    display: none;
                    width: calc(100% - 20px);
                    margin-left: auto;
                    margin-right: auto;
                    margin-bottom: 16px;
                    height: 31px;
                    background: rgba(0, 0, 0, 0.6);
                    border: 1px solid #ED1163;
                    position: relative;
                    z-index: 1;
                    text-decoration: none;

                    p{
                        font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        // font-weight: 700;
                        font-size: 12px;
                        line-height: 33px;
                        text-align: center;

                        color: #FFFFFF;
                        margin: 0;
                    }
                }


                .featured__image{
                    clip-path: polygon(0 0, 100% 19%, 100% 100%, 0% 100%);
                    height: 321px;
                    // background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(0deg, rgba(92, 44, 144, 0.3), rgba(92, 44, 144, 0.3)), url('/images/news/placeholders/futures_leaders_summit.png');
                    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

                    z-index: 1;
                    position: relative;
                }

                .progress{
                    // border: 1px solid #666;
                    height: 3px;
                    width: 100%;
                    position: relative;
                    z-index: 1;
                    
                    .in {
                        height: 100%;
                        background-color: #ED1163;
                        width: 0%;

                        // start the animation
                        &.animate{
                            animation: fill 15s linear;
                        }
                    }

                    @keyframes fill {
                        0% {
                            width: 0%;
                        }
                        100% {
                            width: 100%;
                        }
                    }
                }
            }

            display: flex;
            flex-direction: column;
            // margin-top: 33px;
            // margin-bottom: 58px;
            padding-bottom: 128px;
            margin-top: auto;
            margin-bottom: auto;


            a.read__more{
                background: rgba(0, 0, 0, 0.6);
                box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                width: 100%;
                height: 50px;
                margin-bottom: -9px;
                cursor: pointer;
                user-select: none;
                position: relative;
                overflow-y: hidden;
                z-index: 4;
                text-decoration: none;

                p{
                    font-family: "DIN Next LT Pro Medium", Tahoma, Verdana, sans-serif;
                    font-style: normal;
                    font-weight: 500;
                    font-size: 19px;
                    line-height: 50px;
                    text-align: center;
                    // letter-spacing: 0.2em;
                    margin: 0 auto;

                    color: #FFFFFF;
                    position: relative;
                    z-index: 4;
                }

                div.span_bg{
                    background: linear-gradient(90deg, #ED1163 0%, #5C2C90 96.27%);
                    height: 100%;
                    width: 100%;
                    transition: all .3s ease-in-out;
                    margin-top: auto;
                    margin-bottom: 0;
                    opacity: 0;

                    position: absolute;
                    bottom: -50px;
                    z-index: 3;
                }

                &:hover{
                    div.span_bg{
                        height: calc(100%);
                        bottom: 0;
                        opacity: 1;
                    }
                }
            }

        }

        .mobile__navigation{
            display: none;
            flex-direction: row;
            margin-top: 27px;

            .next, .prev{
                height: 56px;
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: center;

                // border-bottom: 1px solid #ED1163;

                img{
                    display: block;
                    width: 24px;
                    height: 24px;
                    margin-top: auto;
                    margin-bottom: auto;
                }

                .text{
                    font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;
                    font-style: normal;
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 14px;

                    text-transform: uppercase;

                    color: #ED1163;
                    margin: 0;
                    // margin-top: auto;
                    margin-top: 23px;
                    margin-bottom: auto;
                }
            }

            .next{
                border-right: 1px solid #ED1163;
                
                img{
                    margin-right: 8px;
                }
            }

            .prev{
                border-left: 1px solid #ED1163;

                img{
                    margin-left: 8px;
                }
            }
        }
    }

    @media screen and (max-width: 836px) {

        .news__slider{
            padding-top: 0;
            flex-direction: column;
            min-width: initial;
            max-width: initial;
            width: calc(100% - 20px);
            margin-left: auto;
            margin-right: auto;

            img.slider_icon{
                display: none;
            }

            .mobile__headline{
                display: flex;
            }

            .mobile__navigation{
                display: flex;
            }

            .current__news{
                padding-bottom: 0;

                .wrapper{
                    background: linear-gradient(90deg, #ED1163 0%, #5C2C90 75%);

                    .subline__date{
                        padding: 10px;
                        
                        .subline{
                            font-size: 12px;
                            line-height: 14px;
                            color: white;
                        }
                    }

                    .headline__shortdesc{
                        padding: 0 10px;
                        
                        .headline{
                            font-size: 25px;
                            line-height: 30px;
                            min-height: initial;
                            height: 60px;
                            overflow-y: hidden;
                            margin-bottom: 0;
                        }
                        
                        .short_desc{
                            font-size: 14px;
                            line-height: 17px;
                        }
                    }

                    .featured__image{
                        clip-path: none;
                        height: 180px;
                        margin: 10px;
                    }

                    .mobile__link{
                        display: block;
                    }

                    .right_overlay{
                        height: 100%;
                    }
                }

                .read__more{
                    display: none;
                }
            }

        }

    }

    @media screen and (min-width: 836px) and (max-height: 900px) {
        .news__slider{
            .current__news{
                .wrapper{

                    .subline__date{
                        padding-top: 24px;
                    }

                    .headline__shortdesc{
                        .headline{
                            min-height: initial;
                            height: 60px;
                            overflow-y: hidden;
                        }

                        .short_desc{
                            margin-bottom: 12px;
                        }
                    }

                    .featured__image{
                        height: 251px;
                    }
                }
            }
        }
    }

</style>
